import api from './client';

export const getCurrentLocations = () => api.get('/locations/current').then(r => r.data);
export const getLocationHistory = (userId, params) =>
  api.get(`/locations/${userId}/history`, { params }).then(r => r.data);
